import { usePLMapboxDeckStore as t } from "./index.es23.js";
const e = () => t((o) => o.actions);
export {
  e as usePLMapboxDeckActions
};
//# sourceMappingURL=index.es24.js.map
